const blog = {
    title: 'Uzzini vairāk',
    seeAll: 'Rādīt visu',
}

export default blog
